import React from 'react';
import { Markdown } from 'seedly-component-library';

const AboutCard = (props: { content: string }) => {
  const { content } = props;
  return (
    <div className="card">
      {content ? (
        <div className="about-content" data-testid="group-about-content">
          <Markdown source={content} />
        </div>
      ) : null}
    </div>
  );
};

export default AboutCard;
